import React, { useEffect, useState } from "react";
import { loadSetting, saveSettings } from "../utils/Network";

export default function SettingsGeneralContent() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [spotify, setSpotify] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [twitter, setTwitter] = useState("");
  const [settingsId, setSettingsId] = useState(null);

  useEffect(() => {
    setLoading(true);
    loadSetting()
      .then((setting) => {
        if (!setting) {
          return;
        }
        setSettingsId(setting.id || null);
        setTitle(setting.title || "");
        setImage(setting.image || null);
        setMetaDescription(setting.meta_description || "");
        setMetaKeywords(setting.meta_keywords || "");
        setFacebook(setting.facebook || "");
        setInstagram(setting.instagram || "");
        setYoutube(setting.youtube || "");
        setSpotify(setting.spotify || "");
        setLinkedin(setting.linkedin || "");
        setTwitter(setting.twitter || "");
      })
      .finally(() => setLoading(false));
  }, []);

  const onFileChange = (event) => {
    const nextFile = event.target.files && event.target.files[0];
    if (!nextFile) {
      return;
    }
    setFile(nextFile);
    setImage(nextFile);
  };

  const saveChanges = () => {
    setError(null);
    if (!title?.trim()) {
      setError("Please enter Title");
      return;
    }

    setLoading(true);
    saveSettings(
      settingsId,
      title,
      metaDescription,
      metaKeywords,
      facebook,
      instagram,
      youtube,
      spotify,
      linkedin,
      twitter,
      file
    )
      .then((data) => {
        if (data?.id) {
          setSettingsId(data.id);
          setImage(data.image || image);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <h3 className="box-title mb-10">General Settings</h3>
        <ol className="breadcrumb">
          <li>
            <a href="/cms">
              <i className="fa fa-dashboard"></i> Home
            </a>
          </li>
          <li>
            <a href="/cms/settings">Setting</a>
          </li>
          <li className="active">General</li>
        </ol>
      </section>

      <section className="content padding-top-sm-0">
        <div className="row">
          <div className="col-md-8">
            <div className="box">
              <div className="box-header">Site Settings</div>
              <div className="box-body padding-10">
                <div className="form-group">
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="form-control post-title"
                    placeholder="Title"
                  />
                </div>
                <div className="form-group mb-15">
                  <textarea
                    className="form-control"
                    onChange={(e) => setMetaDescription(e.target.value)}
                    placeholder="Meta Description"
                    value={metaDescription}
                    rows="5"
                  ></textarea>
                </div>
                <div className="form-group mb-15">
                  <textarea
                    className="form-control"
                    onChange={(e) => setMetaKeywords(e.target.value)}
                    placeholder="Meta Keywords"
                    value={metaKeywords}
                    rows="5"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="box">
              <div className="box-header">Information</div>
              <div className="box-body">
                <div className="form-group hide">
                  <img
                    className="img upload-img mb-5"
                    src={
                      image && typeof image === "string"
                        ? image
                        : "/assets/cms/assets/dist/img/user2-160x160.jpg"
                    }
                    alt="settings"
                  />
                  <input
                    type="file"
                    name="file"
                    onChange={onFileChange}
                    className="form-control max-w-200"
                  />
                </div>
                <div className="form-group mb-5">
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={facebook}
                      onChange={(e) => setFacebook(e.target.value)}
                      className="form-control"
                      placeholder="Facebook"
                    />
                  </div>
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={instagram}
                      onChange={(e) => setInstagram(e.target.value)}
                      className="form-control"
                      placeholder="Instagram"
                    />
                  </div>
                </div>
                <div className="form-group mb-5">
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={youtube}
                      onChange={(e) => setYoutube(e.target.value)}
                      className="form-control"
                      placeholder="Youtube"
                    />
                  </div>
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={spotify}
                      onChange={(e) => setSpotify(e.target.value)}
                      className="form-control"
                      placeholder="Spotify"
                    />
                  </div>
                </div>
                <div className="form-group mb-5">
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={linkedin}
                      onChange={(e) => setLinkedin(e.target.value)}
                      className="form-control"
                      placeholder="Linkedin"
                    />
                  </div>
                  <div className="col-md-12 mb-5">
                    <input
                      type="text"
                      value={twitter}
                      onChange={(e) => setTwitter(e.target.value)}
                      className="form-control"
                      placeholder="Twitter"
                    />
                  </div>
                </div>
              </div>
              <div className="box-footer">
                <button className="btn btn-primary pull-right" onClick={saveChanges}>
                  Save Changes
                </button>
                <a href="/cms/settings" className="btn btn-default pull-left">
                  Back
                </a>
              </div>
              {error && <div className="alert alert-danger mt-5">{error}</div>}
              {loading && <div className="alert alert-info mt-5">Please Wait...</div>}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
